const URL = "https://visonic-back.herokuapp.com/api/";

export default {
  addUser: URL + "user",
  getAvailableGifts: URL + "gift-product",
  login: URL + "user",
  forgotPassword: URL + "password/send",
  supportCase: URL + "support/case ",
  verifyRecaptcha: URL + "recaptcha",
  verifyBarcode: URL + "installation",
  howToKnowledgeItems: URL + "knowledge/howto",
  tipKnowledgeItems: URL + "knowledge/tips",
  updateUser: URL + "user/",
  addGift: URL + "gift",
  getInstallers: URL + "installer",
};
